import types from './constants'

export default {
  [types.IS_LISTENING_CHANGE]: (isListening) => ({
   type: types.IS_LISTENING_CHANGE,
   isListening
  }),
}
